import { getStorage, ref, uploadBytes } from "firebase/storage";

import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { v4 } from "uuid";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_CONFIG_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_CONFIG_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_CONFIG_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_CONFIG_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MENSSAGING_STORAGE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_CONFIG_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

//const analytics = getAnalytics(app);

const storage = getStorage(app);

export function uploadFile(file, account, challengeId) {
  const storageRef = ref(storage, `challenges/${account}/challengeId/${v4()}`);
  uploadBytes(storageRef, file).then((snapshot) => console.log("OK"));
}
